import { render, staticRenderFns } from "./ProductizeTransformedAttributes.vue?vue&type=template&id=cca07866&scoped=true"
import script from "./ProductizeTransformedAttributes.vue?vue&type=script&lang=js"
export * from "./ProductizeTransformedAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca07866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca07866')) {
      api.createRecord('cca07866', component.options)
    } else {
      api.reload('cca07866', component.options)
    }
    module.hot.accept("./ProductizeTransformedAttributes.vue?vue&type=template&id=cca07866&scoped=true", function () {
      api.rerender('cca07866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ProductizeTransformedAttributes.vue"
export default component.exports